import React, { useRef, useState } from "react";
import { SimpleLoading, HeaderHLPure, DialogSystemGLPure, PromotionalFooterPure, ButtonHLPure, GridSelectionHLPure, DialogYesNoHLPure } from "../../pures";
import { Grid } from '@material-ui/core'
import { ArrowBtnMobile } from "../../../assets/logos/icons";
import ModalUploadIdentityDocument from "./modal-upload-identity-document";
import "./upload-identity-document.css";

const UploadIdentityDocumentView = (props) => {
    let { 
        t,
        history,
        isLoadingView,
        showLoadingRequesting,
        toggleErrorRequesting,
        showCompletedRequesting,
        toggleLoadingRequesting,
        toggleCompletedRequesting,
        showErrorRequesting,
        showWarningRequesting,
        messageComplete,
        messageError,
        messageWarning,
        toggleWarningRequesting,
        documents,
        documentIdentitySelected,
        selectedFile,
        handleDeleteFile,
        uploadIdentityDocument,
        titleHeader,
        showBtnNext,
        showBtnReject,
        labelBtnNext,
        labelBtnReject,
        handleReject
    } = props

    const fileRef = useRef(null);

    const [showModalUpload, setShowModalUpload] = useState(false)
    const [documentSelected, setDocumentSelected] = useState(null)
    const [showModalDelete, setShowModalDelete] = useState(false)

    const headerColumnOne = (props) => {
        return <span className="uploadIdentityDocument-header-cell-one">{props.title}</span>;
    };

    const headerColumnTwo = (props) => {
        return <span className="uploadIdentityDocument-header-cell-two">{props.title}</span>;
    };

    const cellColumnOne = (props) => {
        return (
            <td className="uploadIdentityDocument-cell-one">
                <div className='uploadIdentityDocument-container-cell-one'>
                    <span className="gridHLPure-userName">
                        {props.dataItem.name}
                    </span>
                    <span className="gridHLPure-fieldSubtitle">
                        {props.dataItem.status}
                    </span>
                </div>
            </td>
        );
    };

    const cellColumnTwo = (props) => {
        return(
            <td className="uploadIdentityDocument-cell-two">
                <div className="uploadIdentityDocument-btns-actions">
                    <div className={"cellActions-containerBtnsDetails"}>
                        <button
                            className="cellActions-btn"
                            onClick={() => handleShowModalUpload(props.dataItem)}
                        >
                            <p className="cellActions-textBotton">{t("uploadIdentityDocument.btn.upload")}</p>
                        </button>
                    </div>
                    {
                        (props.dataItem.status !== t("uploadIdentityDocument.documents.status.pending")) && (
                            <div className={"cellActions-containerBtnsDetails"}>
                                <button
                                    className="cellActions-btn"
                                    onClick={() => handleShowModalDelete(props.dataItem)}
                                >
                                    <p className="cellActions-textBotton">{t("uploadIdentityDocument.btn.delete")}</p>
                                </button>
                            </div>
                        )
                    }
                </div>
                <div className="cellActions-mobileExpanded" onClick={() =>handleShowModalUpload(props.dataItem)}>
                    <img
                        className="cellActions-icon-arrow"
                        alt={"cellActions-arrow"}
                        src={ArrowBtnMobile}
                    />
                </div>
            </td>
        )
    }

    let heightGrid = '320px'

    if(documents.length === 1 || documents.length === 0){
        heightGrid = '110px'
    }else if(documents.length === 2){
        heightGrid = '180px'
    }else if(documents.length === 3){
        heightGrid = '280px'
    }else{
        heightGrid = '320px'
    }

    const handleBack  = () => {
        history.goBack()
    }

    const toggleModalUpload = (valueDocument, valueModal) => {
        setDocumentSelected(valueDocument)
        setShowModalUpload(valueModal)
    }

    const closeModalUpload = () => {
        setShowModalUpload(false)
    }

    const handleShowModalUpload = (document) => {
        toggleModalUpload(document, true)
    }

    const handleShowModalDelete = (document) => {
        //verify if existe a file to this document
        let fileExist = true
        documents.map((doc) => {
            if(doc.id === document.id && !document.file){
                fileExist = false
            }
            return doc
        })

        if(!fileExist){
            toggleModalDelete(null, false)
            toggleWarningRequesting(t("uploadIdentityDocument.errors.document.not.exist"), 4000, false, "/")
            return
        }

        toggleModalDelete(document, true)
    }

    const handleDeleteDocument = () => {
        toggleModalDelete(null, false)
        handleDeleteFile(documentSelected)
    }

    const toggleModalDelete = (valueDocument, valueModal) => {
        setDocumentSelected(valueDocument)
        setShowModalDelete(valueModal)
    }

    if(isLoadingView) return <SimpleLoading />

    return(
        <div className="uploadIdentityDocument-wrapper">
            <div className="uploadIdentityDocument-header">
                <HeaderHLPure title={t(`uploadIdentityDocument.title.${titleHeader}`)} />
            </div>
            <div className="uploadIdentityDocument-body">
                <div className="uploadIdentityDocument-elements-container">
                    <div className="uploadIdentityDocument-documents">
                        <div item className="uploadIdentityDocument-grid-documents">
                            <GridSelectionHLPure
                                styleGeneral={true}
                                styleGeneralClass={"uploadIdentityDocument-general-grid"}
                                pageable={false}
                                skip={0}
                                take={documents.length}
                                dataGrid={documents}
                                filter={false}
                                columnTwo={true}
                                titleRow1={t("uploadIdentityDocument.title.1")}
                                titleRow2={t("uploadIdentityDocumenttitle.actions")}
                                headerColumnOne={headerColumnOne}
                                headerColumnTwo={headerColumnTwo}
                                cellColumnOne={cellColumnOne}
                                cellColumnTwo={cellColumnTwo}
                                styleGrid={{ height: heightGrid }}
                            />
                        </div>        
                    </div>
                    <div className="uploadIdentityDocument-btns">
                        <ButtonHLPure
                            nameBtn={t("button.return")}
                            primary={false}
                            onClickBtn={(e) => handleBack(e)}
                        />
                        {
                            showBtnReject && (
                                <ButtonHLPure
                                    nameBtn={labelBtnReject}
                                    onClickBtn={() => handleReject()}
                                    primary={false}
                                />
                            )
                        }
                        {
                            showBtnNext && (
                                <ButtonHLPure
                                    nameBtn={t(labelBtnNext)}
                                    onClickBtn={(e) =>uploadIdentityDocument(e)}
                                    primary={true}
                                />
                            )
                        }
                    </div>
                </div>
            </div>
            <input
                ref={fileRef}
                onChange={(e) => console.log(e)}
                type="file"
                id="identityDocument"
                accept="application/pdf"
                style={{ display: "none" }}
            />
            <Grid item xs={12} lg={12} md={12} sm={12}>
                <PromotionalFooterPure />
            </Grid>
            {
                showModalUpload && (
                    <ModalUploadIdentityDocument 
                        {...props}

                        documentSelected={documentSelected}

                        toggleModalUpload={toggleModalUpload}
                        closeModalUpload={closeModalUpload}
                    />
                )
            }
            {
                showModalDelete && (
                    <DialogYesNoHLPure      
                        cancel={() => toggleModalDelete(null, false)}
                        textBtnCancel={t("button.cancel")}
                        saveBtn={t("button.delete")}
                        titleDialog={t("uploadIdentityDocument.modals.delete.title")}
                        handleSubmit={() => handleDeleteDocument()}
                    >
                        <div className='uploadIdentityDocument-modal'>
                            <h1>{t("uploadIdentityDocument.modals.delete.question")}</h1>
                        </div>
                    </DialogYesNoHLPure>
                )
            }
            <DialogSystemGLPure
                showLoadingRequesting={showLoadingRequesting}
                toggleLoadingRequesting={toggleLoadingRequesting}

                showCompletedRequesting={showCompletedRequesting}
                toggleCompletedRequesting={toggleCompletedRequesting}
                messageComplete={messageComplete}

                showErrorRequesting={showErrorRequesting}
                toggleErrorRequesting={toggleErrorRequesting}
                messageError={messageError} 

                toggleWarningRequesting={toggleWarningRequesting}
                showWarningRequesting={showWarningRequesting}
                messageWarning={messageWarning}
            />
        </div>
    )
}

export { UploadIdentityDocumentView as default }